import { DataTable } from '@uhg-abyss/web/ui/DataTable';
import { useDataTable } from '@uhg-abyss/web/hooks/useDataTable';

import React, { useEffect } from 'react';
import { maskUsingUserAccess } from '@src/utils';
import { mapV1ColumnsToV2, withRowIds } from '@src/utils/tableUtils';
import { HEADER_THEME_CSS } from '@src/common/Table';
import { useAuth } from '@src/Providers/AuthProvider';

export const DetailViewTable = ({ detailViewList }) => {
  const { user } = useAuth();
  const columns = React.useMemo(() => {
    return [
      {
        Header: 'Field Name',
        accessor: 'fieldName',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        width: 300,
        label: 'Field Name',
        Cell: ({ row }) => {
          return row?.original?.isHighlight ? (
            <span style={{ backgroundColor: 'yellow' }}>
              {row?.original?.fieldName || ''}
            </span>
          ) : (
            row?.original?.fieldName || ''
          );
        },
      },

      {
        Header: 'Data Prior To Processing',
        accessor: 'dataBeforeProcessing',
        width: 300,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        label: 'Data Prior To Processing',
        Cell: ({ row }) => {
          return row?.original?.isHighlight ? (
            <span style={{ backgroundColor: 'yellow' }}>
              {row?.original?.dataBeforeProcessing || ''}
            </span>
          ) : (
            row?.original?.dataBeforeProcessing || ''
          );
        },
      },
      {
        Header: 'Incoming Customer Data',
        accessor: 'incomingCustomerData',
        canToggleVisibilty: true,
        width: 300,
        isHiddenByDefault: false,
        label: 'Incoming Customer Data',
        Cell: ({ row }) => {
          return row?.original?.isHighlight ? (
            <span style={{ backgroundColor: 'yellow' }}>
              {typeof row?.original?.incomingCustomerData === 'object'
                ? ' '
                : row?.original?.incomingCustomerData}
            </span>
          ) : typeof row?.original?.incomingCustomerData === 'object' ? (
            ' '
          ) : (
            row?.original?.incomingCustomerData
          );
        },
      },

      {
        Header: 'Data After Processing',
        accessor: 'dataAfterProcessing',
        canToggleVisibilty: true,
        width: 300,
        isHiddenByDefault: false,
        label: 'Data After Processing',
        Cell: ({ row }) => {
          return row?.original?.isHighlight ? (
            <span style={{ backgroundColor: 'yellow' }}>
              {row?.original?.dataAfterProcessing || ''}
            </span>
          ) : (
            row?.original?.dataAfterProcessing || ''
          );
        },
      },
    ];
  }, []);

  const v2Columns = React.useMemo(() => mapV1ColumnsToV2(columns), [columns]);

  const dataTableProps = useDataTable<any>({
    initialData: [] as any[],
    initialColumns: v2Columns,
    rowIdKey: 'uniqueId',
    paginationConfig: { enablePagination: false },
  });

  useEffect(() => {
    if (v2Columns?.length) {
      dataTableProps.setColumns(v2Columns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [v2Columns]);
  function camelCaseToTitleCase(camelCase) {
    if (!camelCase) return '';
    const result = camelCase?.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
  function maskSSN(ssn) {
    const maskedValue = maskUsingUserAccess(
      ssn,
      'Social Security Number',
      user?.maskingType || 0
    );

    return maskedValue;
  }
  useEffect(() => {
    if (detailViewList) {
      let arr: any[] = [];
      arr = [...arr, detailViewList];

      const modifiedArr: any[] = [];
      const keys = Object.keys(arr[0]?.dataAfterProcessing);
      const valuesAfter = Object.values(arr[0]?.dataAfterProcessing) as any[];
      const valuesBefore = Object.values(
        arr[0]?.dataPriorToProcessing
      ) as any[];
      const incomingCustomerData = Object.values(
        arr[0]?.incomingCustomerData
      ) as any[];

      for (let num = 0; num < keys.length; num++) {
        if (
          keys[num] != 'address' &&
          keys[num] != 'coverages' &&
          keys[num] != 'policyamnt' &&
          keys[num] != 'docssup' &&
          keys[num] != 'authresp' &&
          keys[num] != 'broker' &&
          keys[num] != 'sponsor' &&
          keys[num] != 'gpsMemberAddressList' &&
          keys[num] != 'gpsMemberContactList'
        ) {
          var datAftProcValue;
          var datBefProcValue;
          var incomCustData;
          if (
            camelCaseToTitleCase(keys[num]).includes('Social Security Number')
          ) {
            datAftProcValue =
              maskSSN(valuesAfter[num]) !== 'undefined'
                ? maskSSN(valuesAfter[num])
                : '';
            datBefProcValue =
              maskSSN(valuesBefore[num]) !== 'undefined'
                ? maskSSN(valuesBefore[num])
                : '';
            incomCustData =
              maskSSN(incomingCustomerData[num]) !== 'undefined'
                ? maskSSN(incomingCustomerData[num])
                : '';
          } else {
            datAftProcValue = valuesAfter[num];
            datBefProcValue = valuesBefore[num];
            incomCustData = incomingCustomerData[num];
          }
          modifiedArr.push({
            fieldName: camelCaseToTitleCase(keys[num]),
            dataAfterProcessing: datAftProcValue,
            dataBeforeProcessing: datBefProcValue,
            incomingCustomerData: incomCustData,
            isHighlight: !!(
              datAftProcValue?.length > 0 &&
              datBefProcValue?.length > 0 &&
              datAftProcValue?.trim().toLowerCase() !==
                datBefProcValue?.trim().toLowerCase()
            ),
          });
        } else if (keys[num] == 'address') {
          const addressArrayAfter = valuesAfter[num];
          const addressArrayBefore = valuesBefore[num];
          const addressArrayIncoming = incomingCustomerData[num];

          for (let i = 0; i < addressArrayAfter?.length; i++) {
            const addressKeys = Object.keys(addressArrayAfter[i]);
            const addressValuesAfter =
              addressArrayAfter && addressArrayAfter[i]
                ? Object?.values(addressArrayAfter[i])
                : null;
            const addressValuesBefore =
              addressArrayBefore && addressArrayBefore[i]
                ? Object?.values(addressArrayBefore[i])
                : null;
            const addressValuesIncoming =
              addressArrayIncoming && addressArrayIncoming[i]
                ? Object?.values(addressArrayIncoming[i])
                : null;

            for (let j = 0; j < addressKeys?.length; j++) {
              modifiedArr.push({
                fieldName: camelCaseToTitleCase(addressKeys[j]),
                dataAfterProcessing: addressValuesAfter
                  ? (addressValuesAfter[j] as string)
                  : null,

                dataBeforeProcessing: addressValuesBefore
                  ? (addressValuesBefore[j] as string)
                  : null,
                incomingCustomerData: addressValuesIncoming
                  ? (addressValuesIncoming[j] as string)
                  : null,
                isHighlight: !!(
                  addressValuesAfter != null &&
                  addressValuesBefore != null &&
                  (addressValuesAfter as string[])[j]?.length > 0 &&
                  (addressValuesBefore as string[])[j]?.length > 0 &&
                  (addressValuesAfter as string[])[j]?.trim().toLowerCase() !==
                    (addressValuesBefore as string[])[j]?.trim().toLowerCase()
                ),
              });
            }
          }
        } else if (
          keys[num] == 'coverages' ||
          keys[num] == 'policyamnt' ||
          keys[num] == 'docssup' ||
          keys[num] == 'authresp' ||
          keys[num] == 'sponsor' ||
          keys[num] == 'broker' ||
          keys[num] == 'gpsMemberAddressList' ||
          keys[num] == 'gpsMemberContactList'
        ) {
          const subArrayAfter = valuesAfter[num];
          const subArrayBefore = valuesBefore[num];
          const subArrayIncoming = incomingCustomerData[num];

          for (let i = 0; i < subArrayAfter?.length; i++) {
            const subKeys = Object.keys(subArrayAfter[i]);
            const subValueAfter =
              subArrayAfter && subArrayAfter[i]
                ? Object?.values(subArrayAfter[i])
                : null;

            const subValueBefore =
              subArrayBefore && subArrayBefore[i]
                ? Object.values(subArrayBefore[i])
                : null;

            const subValuesIncoming =
              subArrayIncoming && subArrayIncoming[i]
                ? Object?.values(subArrayIncoming[i])
                : null;

            for (let j = 0; j < subKeys?.length; j++) {
              modifiedArr.push({
                fieldName: camelCaseToTitleCase(subKeys[j]),
                dataAfterProcessing: subValueAfter
                  ? (subValueAfter as string[])[j]
                  : null,
                dataBeforeProcessing: subValueBefore
                  ? (subValueBefore as string[])[j]
                  : null,
                incomingCustomerData: subValuesIncoming
                  ? (subValuesIncoming as string[])[j]
                  : null,
                isHighlight: !!(
                  subValueAfter != null &&
                  subValueBefore != null &&
                  (subValueAfter as string[])[j]?.length > 0 &&
                  (subValueBefore as string[])[j]?.length > 0 &&
                  (subValueAfter as string[])[j]?.trim().toLowerCase() !==
                    (subValueBefore as string[])[j]?.trim().toLowerCase()
                ),
              });
            }
          }
        }
      }

      dataTableProps.setData(withRowIds(modifiedArr));
    }
  }, [detailViewList]);

  return (
    <React.Fragment>
      <DataTable
        title=""
        hideHeader
        tableState={dataTableProps}
        css={{ width: '100%', ...HEADER_THEME_CSS }}
      >
        <DataTable.Table />
      </DataTable>
    </React.Fragment>
  );
};
